<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 content-card">
        <div class="container container-fixed-992">
          <div class="content-card-header">
            <h1><img v-if="icon != ''" :src="$image(`assets/${icon}`)" /> {{ title }}</h1>
            <ButtonElement v-if="step != ''" class="btn--ms btn--neutral">{{ step }}</ButtonElement>
          </div>
        </div>
        <div class="content-card-body">
          <div class="row">
            <div class="col-12">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script lang="ts">
import { defineComponent } from 'vue';
import ButtonElement from '@shared/components/elements/button/button.element.vue';

export default defineComponent({
  name: 'ProfileTemplate',
  components: {
    ButtonElement,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    step: {
      type: String,
      default: '',
    },
  },
});
</script>
<style lang="scss" scoped>
.content-card {
 .content-card-header {

    padding: 0 0 20px 0;
    display: flex;
    justify-content: space-between;

    h1{
      margin: var(--space-0);
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      padding: 5px 10px;
      border-radius: 6px;
      font-weight: 600;
      color:var(--neutral-300);
    }
  }
}
</style>
